module.exports = __webpack_public_path__ + "static/media/tooltip-arrow-bottom.f45624a8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tooltip-arrow-bottom.svg
// module id = 1087
// module chunks = 0